export enum ContactabilityLevel {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  UNREACHABLE = 'UNREACHABLE',
  PENDING = 'PENDING',
  NOT_CONTACTED = 'NOT_CONTACTED',
}

export enum PortfolioTypeExtended {
  UP_TO_DATE = 'U',
  SLOW_PAYER = 'S',
  RECOVERY_CAMPAIGN = 'R',
}

export class ProjectContactabilityStats {
  projectId: string;
  contactabilityStatusDetails: ContactabilityStatusDetails[];
}

export class ContactabilityStatusDetails {
  contactabilityStatus: string;
  totalClientsCount: number;
  upToDateClientsCount?: number | null;
  slowPayerClientsCount?: number | null;
  recoveryCampaignClientsCount?: number | null;
  clientsWithRefsCount: number;
  clientsWithGarsCount: number;
  balance: number;
  currency: string;
}

export const CONTACTABILITY_PORTFOLIO_SITUATION_MAP: Record<PortfolioTypeExtended.UP_TO_DATE | PortfolioTypeExtended.SLOW_PAYER, readonly string[]> = {
  [PortfolioTypeExtended.UP_TO_DATE]: ['U', 'F', 'N'],
  [PortfolioTypeExtended.SLOW_PAYER]: ['S', 'S30', 'S60', 'S90'],
};

export const CONTACTABILITY_RISK_LEVELS = new Set<ContactabilityLevel>([
  ContactabilityLevel.LOW,
  ContactabilityLevel.UNREACHABLE,
]);
